<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2023-02-03 17:36:12
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-27 17:27:02
-->
<template>
  <div class="innovative innovative-accuimr" :class="{textj: language != 'en'}" ref="accuimr">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right flex justify_content_center p-l-30 p-r-30">
        <div class="flex" v-html="$t('product.accuimr.title')"></div>
        <div :class="language == 'en' ? 'p-l-15 textl' : ''">
          <span v-for="(item, index) in $t('product.accuimr.des')" :key="index" v-html="item"></span>
        </div>
      </div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.accuimr.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-30" :class="language == 'en' ? 'p-r-30' : 'p-r-15'">
        <img class="wid100" :src="$t('product.accuimr.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="(item, index) in $t('product.accuimr.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="accuimr-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.accuimr.list[1].title')"></div>
          <div class="accuimr-characteristics-box">
            <div class="p-t-20 p-b-40" v-for="(item, index) in $t('product.accuimr.list[1].des')" :key="index">
              <div class="innovative-wrap-item-title fz-30 p-b-25" v-html="item.title"></div>
              <div class="innovative-characteristics-item" v-for="($item, $index) in item.list" :key="$index" v-html="$item.join('')"></div>
            </div>
            <div v-if="language != 'en'" class="textc">
              <img style="max-width: 70%;" :src="$t('product.accuimr.list[1].img1')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="accuimr-advantages">
      <div class="innovative-item-title p-l-15" style="" v-html="$t('product.accuimr.list[2].title')"></div>
      <div class="innovative-accuimr-m-h">
        <div class="flex align_items_center p-b-40">
          <div class="textc flex_1" v-for="(item, index) in $t('product.accuimr.list[2].list')" :key="index">
            <div class="clearfix">
              <span class="num" v-html="item.num"></span>
              <span class="" v-html="item.unit"></span>
              <span class="posrel color_active l-10 t--6 fz-22" v-html="item.sign"></span>
            </div>
            <div class="fontw p-10 fz-28" v-html="item.title"></div>
          </div>
        </div>
        <div class="textj" v-html="$t('product.accuimr.list[2].des')"></div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-20 article">
        <div class="innovative-item-title" v-html="$t('product.accuimr.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="(item, index) in $t('product.accuimr.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-accuimr {
  .innovative-bj-title {
    top: 60%;
  }
  .accuimr-characteristics {
    background-image: url('~@/assets/images/innovate/AccuIMR/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .accuimr-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 50px 10%;
    }
    .accuimr-characteristics-img {
      max-height: 80px;
    }
  }
  .accuimr-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding: 50px 30px;
  }
  .innovative-accuimr-m-h {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
    padding: 50px 30px;
    .color_active {
      color: #00A4EC;
    }
    .num {
      .color_active;
      font-size: 42px;
      font-weight: 600;
    }
  }
}
</style>
